import React from 'react';

import cx from 'classnames';
import { mergeDeepRight } from 'ramda';

import { EDetailsMode } from 'components/Pages/Admin/Itinerary/Details/types';
import { AIWysiwygWrapper } from 'components/shared/AIWysiwygWrapper';
import { Wysiwyg } from 'components/shared/Wysiwyg';
import { LOREM_IPSUM_TEXT, SYMBOLS_LIMIT } from 'constants/texts';

import LandingPageContext from '../../contexts/LandingPageContext';
import s from './index.module.css';
import { IRichText, IRichTextProps } from './types';

function RichText({ data: blockData, onAdd, onUpdate, onDelete }: IRichTextProps) {
  const { readOnly } = React.useContext(LandingPageContext);
  const { data, withoutRemoving = false } = blockData;

  const handleChange = (newObject: { type: string; data: IRichText }) => {
    onUpdate(mergeDeepRight(blockData, newObject));
  };
  const handleDelete = withoutRemoving ? null : onDelete;

  return (
    <div className={cx(s.wrapper, 'custom-text-wrapper')}>
      <AIWysiwygWrapper detailsMode={EDetailsMode.Original} data={data} onAdd={onAdd} onUpdate={handleChange}>
        {({ onChange, handleKeyBindingFn, handleKeyCommand, WysiwygFooter }) => (
          <Wysiwyg
            type="primary"
            data={data}
            placeholder={data?.placeholder || LOREM_IPSUM_TEXT}
            focusedPlaceholder="Write something, or type “ / ” for AI..."
            onChange={(state) => {
              onChange(state);
              handleChange(state);
            }}
            onDelete={handleDelete}
            handleKeyCommand={handleKeyCommand}
            handleKeyBinding={handleKeyBindingFn}
            limit={SYMBOLS_LIMIT}
            isReadOnly={readOnly}
            hideLimit
            footer={<WysiwygFooter />}
          />
        )}
      </AIWysiwygWrapper>
    </div>
  );
}

export default RichText;
